<script setup lang="ts">
import AMRA_BANK_LOGO from "@/assets/img/amra-bank.png";

const route = useRoute();
const head = computed(() => {
  return {
    title: "Амрабанк",
    meta: [
      {
        hid: "title",
        property: "title",
        content: `Амрабанк`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Амра-банк это дебетовые карты, обмен валюты, обслуживание физических лиц, кредитование бизнеса, аренда сейфовых ячеек, дистанционное обслуживание юридических ли...",
      },
      {
        property: "og:title",
        name: "og:title",
        content: "Амрабанк",
      },
      {
        property: "og:description",
        name: "og:description",
        content:
          "Амра-банк это дебетовые карты, обмен валюты, обслуживание физических лиц, кредитование бизнеса, аренда сейфовых ячеек, дистанционное обслуживание юридических ли...",
      },
      {
        property: "og:url",
        name: "og:url",
        content: `https://amra-bank.com/${route.fullPath}`,
      },
      {
        property: "url",
        name: "url",
        content: `https://amra-bank.com/${route.fullPath}`,
      },
      {
        property: "og:type",
        name: "og:type",
        content: "website",
      },
      {
        property: "og:site_name",
        name: "og:site_name",
        content: "Амрабанк",
      },
      {
        property: "image",
        name: "image",
        content: `${AMRA_BANK_LOGO}`,
      },
      {
        property: "og:image",
        name: "og:image",
        content: `${AMRA_BANK_LOGO}`,
      },
    ],
  };
});

useHead(head);
</script>
<template>
  <NuxtLayout name="default">
    <AVacancies class="mb-5 lg:mb-14"></AVacancies>
    <AQuestionnaire class="mb-14 lg:mb-14"></AQuestionnaire>
  </NuxtLayout>
</template>
